// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_SortArray from "@rescript/runtime/lib/es6/Belt_SortArray.js";
import * as Primitive_object from "@rescript/runtime/lib/es6/Primitive_object.js";

let numberRegExp = /[0-9]+/g;

function padNumbersInString(length, str) {
  return str.replace(numberRegExp, (match, param, param$1) => match.padStart(length, "0"));
}

function stableSortOn(array, key) {
  return Belt_SortArray.stableSortBy(array, (a, b) => Primitive_object.compare(key(a), key(b)));
}

export {
  numberRegExp,
  padNumbersInString,
  stableSortOn,
}
/* No side effect */
